import { graphql } from 'gql.tada';
import { client } from '../client';

const submitMutation = graphql(`
  mutation Submit($input: SubmitInput!) {
    submit(input: $input) {
      status
      email
      info {
        label {
          url
        }
        orderNumber
        returnStatus
      }
      cart {
        refund {
          type
        }
        items {
          resolution
          reason {
            title
            id
            fields {
              value
              type
            }
            children {
              title
              id
              fields {
                value
                type
              }
            }
          }
          quantity
          item {
            variantId
            sku
            id
          }
          id
          exchange {
            variantInfo {
              value
              name
            }
            variantId
            sku
            productId
            price {
              value
              formattedString
              currency
            }
            name
            image
            id
          }
          delivery {
            type
            serviceProviderId
            serviceType
            packagingOption
            locationProviderId
          }
          comment
        }
        id
        delivery {
          type
          serviceProviderId
          serviceType
          packagingOption
          locationProviderId
        }
        customerId
        attributes {
          value
          name
        }
        address {
          provinceCode
          province
          postalCode
          lastName
          firstName
          countryCode
          city
          address2
          address1
        }
        location {
          url
          storeName2
          storeName
          openingHours {
            hours
            day
          }
          longitude
          logoUrl
          latitude
          id
          distance
          display
          attributes {
            value
            name
          }
          address {
            provinceCode
            province
            postalCode
            lastName
            firstName
            countryCode
            city
            address2
            address1
          }
        }
      }
      order {
        shippingAddress {
          provinceCode
          province
          postalCode
          lastName
          firstName
          countryCode
          city
          address2
          address1
        }
        orderNumber
        orderId
        items {
          variant {
            info {
              name
              value
            }
            id
          }
          title
          sku
          reasons {
            title
            retailerReasonCodeId
            retailerReasonCode
            resolutions {
              id
              scope
            }
            parentId
          }
        }
      }
      errorResponse {
        errorMessageDetailCode
        errorMessageDetail
        errorMessage
        errorCode
      }
    }
  }
`);

export const submitMutationFn = async ({ input }: { input: SubmitVariables }) =>
  await client.request(submitMutation, { input });

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type SubmitVariables =
  typeof submitMutation extends import('gql.tada').TadaDocumentNode<
    any,
    infer T,
    any
  >
    ? T extends { input: infer V }
      ? V
      : never
    : never;
/* eslint-enable typescript/no-explicit-any */

export type CartVariables = SubmitVariables['cart'];
export type OrderTokenVariables = SubmitVariables['orderTokens'];
export type OrderMetaDataVariables = SubmitVariables['orderMetaData'];
export type RefundVariables = NonNullable<SubmitVariables['cart']['refund']>;
export type RefundTypeVariables = RefundVariables['type'];
export type ReasonFieldVariables =
  CartVariables['items'][number]['reason']['fields'];

/* eslint-disable typescript/no-explicit-any -- Required for gql.tada type inference */
export type SubmitResponse =
  typeof submitMutation extends import('gql.tada').TadaDocumentNode<
    infer R,
    any,
    any
  >
    ? R
    : never;
/* eslint-enable typescript/no-explicit-any */

export type SubmitOrderInfo =
  | NonNullable<SubmitResponse['submit']['info']>[number]
  | null;

export type SubmitCart = NonNullable<SubmitResponse['submit']['cart']> | null;
export type SubmitCartItem = NonNullable<SubmitCart>['items'][number];
export type SubmitCartLocation = NonNullable<SubmitCart>['location'];
export type SubmitStatus = SubmitResponse['submit']['status'];
